var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="empty"> <div> <div style="background-image:url(\'/images/iphone6v1.png\'); width:549px;height:1149px"> <iframe src="#modelbegin# ImagePrintUrl #modelend#" scrolling="no" style="z-index:1;margin-top:168px;margin-left:36px;width:477px; height:834px;border-width:0px"></iframe> </div> </div> </div>';
}
return __p;
};
